const RESERVED_ROUTE_NAMES = new Set([
  "index", "_app", "_document", "_error", "404", "500", "api",
]);

/**
 * Slugify a route name the same way the backend does.
 * Does NOT strip leading digits — validation catches those.
 */
function slugify(routeName: string): string {
  return routeName
    .toLowerCase()
    .trim()
    .replace(/^\/+/, "")
    .replace(/\/+$/, "")
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9\-/]/g, "")
    .replace(/-{2,}/g, "-")
    .replace(/\/{2,}/g, "/")
    .split("/")
    .map((s) => s.replace(/^-+/, "").replace(/-+$/, ""))
    .filter(Boolean)
    .join("/");
}

/**
 * Validate a route name for page creation.
 * Returns error message or null if valid.
 * Mirrors backend validation in page-manager.ts.
 */
export function validateRouteName(routeName: string): string | null {
  const slug = slugify(routeName);

  if (!slug) {
    return "Route name must contain at least one letter";
  }

  const segments = slug.split("/").filter(Boolean);
  for (const segment of segments) {
    if (/^\d/.test(segment)) {
      return `Route name "${segment}" cannot start with a number`;
    }
    if (!/^[a-z]/.test(segment)) {
      return `Route name "${segment}" must start with a letter`;
    }
    if (RESERVED_ROUTE_NAMES.has(segment)) {
      return `"${segment}" is a reserved route name`;
    }
  }

  return null;
}
